import React, { useEffect, useRef, useState } from "react";
import Breadcrumbs from "../../components/common/Breadcrumbs";
import "./notification.scss";
import { notificationlist } from "../../actions/notificaion";
import { useDispatch, useSelector } from "react-redux";
import { chatNotificationCountAction } from "../../actions/meta";
import InfiniteScroll from "react-infinite-scroll-component";
import { Loading } from "../../components/common/LoderData";
import NotificationData from "./notificationData";

const bread = [
  {
    name: "Notification",
    link: "/notification",
    isActive: true,
  },
];
const PAGE_SIZE = 10;

function Notification() {
  const notifictiodata = useSelector(
    (state) => state.NotifictionReducer.notifictionlist
  );
  const dispatch = useDispatch();
  const [nextCursor, setNextCursor] = useState(null);
  const [hasMore, setHasMore] = useState(true);
  const loadingRef = useRef(false);

  // Cursor paging: the API returns pagination.nextCursor/hasMore, and the
  // cursor keeps the next page stable when rows are deleted or added.
  const fetchData = (cursor = null) => {
    if (loadingRef.current) return;
    loadingRef.current = true;
    dispatch(
      notificationlist(
        { limit: PAGE_SIZE, ...(cursor ? { cursor } : { page: 1 }) },
        false,
        !cursor
      )
    )
      .then((res) => {
        // The first page marks everything read, so refresh the bell.
        if (!cursor) dispatch(chatNotificationCountAction());
        setNextCursor(res?.pagination?.nextCursor || null);
        setHasMore(Boolean(res?.pagination?.hasMore));
      })
      .catch(() => setHasMore(false))
      .finally(() => {
        loadingRef.current = false;
      });
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // A page that doesn't fill the window can't be scrolled, so load the next one.
  useEffect(() => {
    if (
      hasMore &&
      nextCursor &&
      document.documentElement.scrollHeight <= window.innerHeight
    ) {
      fetchData(nextCursor);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notifictiodata, hasMore, nextCursor]);

  return (
    <>
      <section className="notification">
        <div className="container">
          <div className="breadcrumbsNotification">
            <Breadcrumbs list={bread} />
          </div>
        </div>
        <div className="container">
          {notifictiodata?.length ? (
            <InfiniteScroll
              dataLength={notifictiodata?.length}
              next={() => fetchData(nextCursor)}
              hasMore={hasMore}
              loader={<Loading />}
            >
              <div>
                {notifictiodata?.map((item, id) => {
                  return (
                    <NotificationData key={item?._id} item={item} idx={id} />
                  );
                })}
              </div>
            </InfiniteScroll>
          ) : (
            <h4 className="notFound">No Notification Found!!!</h4>
          )}
        </div>
      </section>
    </>
  );
}

export default Notification;
